// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bfTrY","copyright":"Footer_copyright__2AvTj"};